import { useContext } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { selectPartners } from '../../../selectors/partners';
import { selectProducts } from '../../../selectors/products';

import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';

import { AUTH_PAIRING_SUCCESS_PROMO_FREEPREMIUM } from '../../../constants/localizations/auth';
import { AUTO_PATH } from '../../../constants/paths';
import { TUNE_IN_BADGE_LOGO } from '../../../constants/localizations/shared';

import { isPairAuthFlowPin } from '../../../utils/auth/pairAuthFlowHelpers';
import findPartnerInfo from '../../../utils/findPartnerInfo';
import { selectProductFromQuery } from '../../../utils/subscription/findProductHelpers';
import TuneInLogo from '../../header/TuneInLogo';

import assetUrl from '../../../utils/assetUrl';
import css from './auth-flow-promo-header.module.scss';

const tiBadgeAssetPath = 'assets/img/ti-badge-white.svg';

const AuthFlowPromoHeader = ({
  partners,
  products,
  hideHeaderText,
  logoContainerClassName,
  useFullTuneInLogo,
  exaggerateMarginTop,
}) => {
  const { getLocalizedText, location } = useContext(
    LocationAndLocalizationContext,
  );
  const { query, pathname } = location;

  const isAutoPath = pathname === AUTO_PATH;
  const showProgressBar = isPairAuthFlowPin(query) || isAutoPath;
  const partnerInfo = findPartnerInfo(location, partners);
  const selectedProduct = selectProductFromQuery(products, location);
  const freeTrialLength = get(selectedProduct, 'freeTrialLength');
  const partnerName = get(partnerInfo, 'name');

  const localizedHeaderText = getLocalizedText(
    AUTH_PAIRING_SUCCESS_PROMO_FREEPREMIUM,
    {
      freeTrialLength,
    },
  );

  const customizedHeaderText =
    partnerName && localizedHeaderText
      ? localizedHeaderText
          .substring(0, localizedHeaderText.lastIndexOf(' '))
          .concat(` ${partnerName}`)
      : localizedHeaderText;

  return (
    <div
      data-testid="authFlowPromoHeaderContainer"
      className={classnames(css.authFlowPromoHeaderContainer, {
        [css.withProgressBar]: showProgressBar,
        [css.exaggerateMarginTop]: exaggerateMarginTop,
      })}
    >
      <div
        className={classnames(
          css.authFlowPromoHeaderLogoContainer,
          logoContainerClassName,
        )}
      >
        {useFullTuneInLogo ? (
          <TuneInLogo unlinkedLogo iconProps={{ width: '100%' }} />
        ) : (
          <img
            className={css.authFlowPromoHeaderBadgeImg}
            src={assetUrl(tiBadgeAssetPath)}
            role="presentation"
            data-testid="authFlowTuneInBadgeImg"
            alt={getLocalizedText(TUNE_IN_BADGE_LOGO)}
          />
        )}
      </div>
      {!hideHeaderText && freeTrialLength && (
        <p
          data-testid="authFlowPromoHeaderText"
          className={css.authFlowPromoHeaderText}
        >
          {customizedHeaderText}
        </p>
      )}
    </div>
  );
};

AuthFlowPromoHeader.propTypes = {
  partners: PropTypes.object,
  products: PropTypes.object,
  hideHeaderText: PropTypes.bool,
  logoContainerClassName: PropTypes.string,
  useFullTuneInLogo: PropTypes.bool,
  exaggerateMarginTop: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  partners: selectPartners(state),
  products: selectProducts(state),
});

export default connect(mapStateToProps)(AuthFlowPromoHeader);
